module.exports = __webpack_public_path__ + "static/img/noData.c685bfbd.png";